var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgS3 = function SvgS3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6875 4.64062L15.7969 12.0469L19.6875 19.4531L21.2812 18.5625V5.53125L19.6875 4.64062Z",
    fill: "#E25444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6875 4.64062L11.9062 5.53125L7.94531 12.0469L11.9062 18.5625L19.6875 19.4531V4.64062Z",
    fill: "#7B1D13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98438 4.64062L2.71875 5.20312V18.8906L3.98438 19.4531L11.9062 12.0469L3.98438 4.64062Z",
    fill: "#58150D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.96736 4.62502L11.9167 6.83334V17.4583L3.96736 19.4583V4.62502Z",
    fill: "#E25444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9209 8.00002L8.54555 7.45833L11.9209 3.62498L15.288 7.45833L11.9209 8.00002Z",
    fill: "#58150D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.288 7.45833L11.9167 8.00831L8.54555 7.45833V3.62498",
    fill: "#58150D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9209 16.0417L8.54555 16.6667L11.9209 19.9583L15.288 16.6667L11.9209 16.0417Z",
    fill: "#58150D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9062 0.75L8.53125 2.53125V7.45312L11.9167 6.50002L11.9062 0.75Z",
    fill: "#7B1D13"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9167 9.20831L8.54555 9.57502V14.4893L11.9167 14.875V9.20831Z",
    fill: "#7B1D13"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9167 17.5L8.54555 16.6547V21.4858L11.9167 23.25V17.5Z",
    fill: "#7B1D13"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.288 16.6547L11.9167 17.5V23.25L15.288 21.4858V16.6547Z",
    fill: "#E25444"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9167 9.20831L15.288 9.57502V14.4893L11.9167 14.875V9.20831Z",
    fill: "#E25444"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9062 0.75L15.2812 2.53125V7.45312L11.9062 6.51562V0.75Z",
    fill: "#E25444"
  })));
};

export { SvgS3 as ReactComponent };
export default "data:image/svg+xml;base64,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";